var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }